import React, { memo, useEffect } from "react";
import "./LineageComponent.scss";
import configStructure from "./configStructure.js";

import { useAxiomState } from "__AxiomComponents/AxiomHooks/AxiomHooks";
import AxiomLoader from "__AxiomComponents/AxiomUI/AxiomLoader/AxiomLoader.jsx";
import ReactFlow, {
  // isEdge,
  // removeElements,
  // addEdge,
  // MiniMap,
  Controls,
  // Background,
} from "react-flow-renderer";

import CustomFlowNode from "./CustomFlowNode.js";
import CustomFlowNodeContainer from "./CustomFlowNodeContainer.js";
// const onLoad = (reactFlowInstance) => reactFlowInstance.fitView();

const nodeTypes = {
  customFlowNode: CustomFlowNode,
  customFlowNodeContainer: CustomFlowNodeContainer,
};

function LineageComponent(props) {
  const [state, dispatch] = useAxiomState(
    {
      loading: true,
    },
    props.appName,
    props.appID,
    "LineageComponent",
    props.componentID
  );

  return (
    <div className="LineageComponent">
      <ReactFlow
        elements={props.lineageData}
        nodeTypes={nodeTypes}
        // onLoad={onLoad}
        onElementClick={props.onElementClick || (() => {})}
        preventScrolling={false}
        zoomOnScroll={false}
        panOnScroll={true}
      >
        <Controls />
      </ReactFlow>
    </div>
  );
}

export default memo(LineageComponent);
